import { render, staticRenderFns } from "./MolliePayment.vue?vue&type=template&id=787981f1&scoped=true"
import script from "./MolliePayment.vue?vue&type=script&lang=ts"
export * from "./MolliePayment.vue?vue&type=script&lang=ts"
import style0 from "./MolliePayment.vue?vue&type=style&index=0&id=787981f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787981f1",
  null
  
)

export default component.exports